import { render, staticRenderFns } from "./LifetimeIsaTransferIn.vue?vue&type=template&id=4c578a6c"
import script from "./LifetimeIsaTransferIn.vue?vue&type=script&lang=js"
export * from "./LifetimeIsaTransferIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports